import React, { useState } from 'react';
import axios from 'axios';
import { Modal } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { BASE_URL } from "../../config/axios";

// Button + Modal combo. Drop this in the table cell where you want
// the "View EOTs" trigger to live. Pass the project/section id.
const cellStyle = {
    border: "0.5px solid #e0e0e0",
    padding: "10px 12px",
    color: "#1e293b",
    whiteSpace: "nowrap",
};

const EOTHistoryButton = ({ projectId, latestEot }) => {
    const [show, setShow] = useState(false);
    const [loading, setLoading] = useState(false);
    const [eotList, setEotList] = useState([]);
    const [eotCount, setEotCount] = useState(null);

    const handleShow = async () => {
        setShow(true);
        setLoading(true);
        try {
            const res = await axios.get(`${BASE_URL}/dpr/eot/list/${projectId}/`);
            // backend Meta.ordering is ascending by eot_no, we want latest first
            const sorted = [...res.data].sort((a, b) => b.eot_no - a.eot_no);
            setEotList(sorted);
            setEotCount(sorted.length);
        } catch (err) {
            console.error("Error fetching EOT history:", err);
            toast.error("Failed to fetch EOT history");
        } finally {
            setLoading(false);
        }
    };

    const handleClose = () => {
        setShow(false);
        setEotList([]);
    };

    // don't render the button at all if there's no EOT for this row
    if (!latestEot) return null;

    return (
        <>
            <button
                title="View EOT History"
                onClick={handleShow}
                style={{
                    border: "1px solid #2576bc",
                    color: "#2576bc",
                    background: "#fff",
                    borderRadius: "99px",
                    padding: "3px 12px",
                    fontSize: "11px",
                    fontWeight: 600,
                    cursor: "pointer",
                    whiteSpace: "nowrap",
                    lineHeight: "1.6",
                }}
            >
                View EOTs{typeof eotCount === "number" ? ` (${eotCount})` : ""}
            </button>

            <Modal show={show} onHide={handleClose} size="xl" dialogClassName="request-leave-document">
                <Modal.Header
                    closeButton
                    className="justify-center task-Tab-heading font-weight500 font-size-heading"
                >
                    <Modal.Title>EOT History</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    {loading ? (
                        <div className="form-loader" style={{ width: "100%" }}>
                            <div className="bar-loader" style={{ width: "100%" }}></div>
                        </div>
                    ) : eotList.length === 0 ? (
                        <p style={{ textAlign: "center", color: "#7a7a7a" }}>No EOTs found.</p>
                    ) : (
                        <div style={{ overflowX: "auto", overflowY: "auto", maxHeight: "60vh", border: "0.5px solid #e0e0e0", borderRadius: "6px" }}>
                            <table
                                style={{
                                    width: "100%",
                                    borderCollapse: "collapse",
                                    fontSize: "13px",
                                }}
                            >
                                <thead>
                                    <tr style={{ background: "#f5f7fa", position: "sticky", top: 0, zIndex: 1 }}>
                                        {[
                                            "Sr. No.",
                                            "Project Code",
                                            "Project Name",
                                            "EOT No.",
                                            "Date of EOT Requested",
                                            "Request Letter No. & Date",
                                            "Approval Date & Letter No.",
                                            "Request Letter",
                                            "Approval Letter",
                                        ].map((header) => (
                                            <th
                                                key={header}
                                                style={{
                                                    border: "0.5px solid #e0e0e0",
                                                    padding: "10px 12px",
                                                    fontSize: "12px",
                                                    fontWeight: 600,
                                                    color: "#374151",
                                                    textAlign: "left",
                                                    whiteSpace: "nowrap",
                                                }}
                                            >
                                                {header}
                                            </th>
                                        ))}
                                    </tr>
                                </thead>
                                <tbody>
                                    {eotList.map((eot, idx) => (
                                        <tr
                                            key={eot.id}
                                            style={{
                                                background: idx === 0 ? "#f5f7fa" : "#fff",
                                            }}
                                        >
                                            <td style={cellStyle}>{idx + 1}</td>
                                            <td style={cellStyle}>{eot.project_code || "—"}</td>
                                            <td style={cellStyle}>{eot.project_name || "—"}</td>
                                            <td style={cellStyle}>
                                                EOT-{eot.eot_no}
                                                {idx === 0 && (
                                                    <span
                                                        style={{
                                                            marginLeft: "6px",
                                                            background: "#dcfce7",
                                                            color: "#16a34a",
                                                            borderRadius: "99px",
                                                            padding: "1px 8px",
                                                            fontSize: "10px",
                                                            fontWeight: 600,
                                                        }}
                                                    >
                                                        Active
                                                    </span>
                                                )}
                                            </td>
                                            <td style={cellStyle}>{eot.applied_date || "—"}</td>
                                            <td style={cellStyle}>
                                                {eot.applied_letter_no || "—"}
                                                {eot.applied_date ? ` / ${eot.applied_date}` : ""}
                                            </td>
                                            <td style={cellStyle}>
                                                {eot.approval_date || "—"}
                                                {eot.approval_letter_no ? ` / ${eot.approval_letter_no}` : ""}
                                            </td>
                                            <td style={cellStyle}>
                                                {eot.applied_letter ? (
                                                    <a href={eot.applied_letter} target="_blank" rel="noopener noreferrer">
                                                        View
                                                    </a>
                                                ) : (
                                                    "—"
                                                )}
                                            </td>
                                            <td style={cellStyle}>
                                                {eot.approval_letter ? (
                                                    <a href={eot.approval_letter} target="_blank" rel="noopener noreferrer">
                                                        View
                                                    </a>
                                                ) : (
                                                    "—"
                                                )}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    )}
                </Modal.Body>
            </Modal>
        </>
    );
};

export { EOTHistoryButton };
export default EOTHistoryButton;